import { LoadableLazy } from '@confluence/loadable';

export const HorizontalFilters = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HorizontalFilterPane" */
				'./HorizontalFilters.tsx'
			)
		).HorizontalFilters,
});
